module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAUBJREFUSEvtVsFxAjEM3P2nCOggHQQqASpJKCOvQAd0APlRQP6hE2XWI2WEY+eB78Wgz91Zttc6rbQmKjOzBYAPALPaB+CSxmq/fDuS27yO+cPMtOjoG+l94/4Lybx5Gfb5eo0Dac6W5Cn2vQKIQTN7BbAguWxE8WfIzHSoU316TXwARC6m+UWeVOVmV5HjdgDfdCZmmJnYItv791pgQ0lO1BW/xS7ZbwRizhBA4rtO/w7g7LxXFAVoCMAj0Oaq8DcAawAHAM8qSJKbIYAqgj2AFwBPAL6isKYAKCyJBMcvEthwBMEi708rB/mcjEWPXnRn3TTJpXIrdRLv9bxStKRkIZsqRM0rKthVtNR3WnocoD1f8ZOcdzXZq1YtQYV1iy3z6buSmdqDCkv9p2fNm8S/EYTTzL47V5cWmAS/eUH4AVeeDSiZBDjgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/img/inse.png
// module id = hV/B
// module chunks = 1